import { isNil } from "lodash";
import { formatDateShort } from "../../../utils/dates/formatDateShort";
import { getDaysAgo } from "./getDaysAgo";

export const getDaysAgoFormatted = (date) => {
  if (isNil(date)) {
    return "Unknown";
  }
  const daysAgoCount = getDaysAgo(date);

  if (daysAgoCount === 0) {
    return "Today";
  }
  if (daysAgoCount === 1) {
    return `1 day ago`;
  }

  if (daysAgoCount > 60) {
    return `on ${formatDateShort(date)}`;
  }

  return `${daysAgoCount} days ago`;
};
